import { render, staticRenderFns } from "./term9.vue?vue&type=template&id=04f168c8"
import script from "./term9.vue?vue&type=script&lang=js"
export * from "./term9.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports